import React from 'react';
import { FormularioPedido } from '../../../componentes/formulario-pedido/form-pedido';


const FormSalvarPedido = (props) => {
    return <FormularioPedido tipo="PEDIDO" { ...props } ></FormularioPedido>
}

export {FormSalvarPedido}; 

//module.exports = {FormSalvarPedido:FormSalvarPedido, Teste: Teste}; 